import React from 'react'
import PropTypes from 'prop-types';

import { TextInput, LabelGroup, Section, Flex } from '~/views';
import BaseAttributeEditor from './BaseAttributeEditor';
import { UpdaterSelector, UpdaterFactory } from '~/editors/updaters';

import './style.css'

export default class StringAttributeEditor extends React.Component {

  static propTypes = {
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props );
    this.changePath = BaseAttributeEditor.ChangePath.bind( this )
    this.onUpdaterChange = BaseAttributeEditor.OnUpdaterChange.bind( this )
    this.onSelectUpdater = this.onSelectUpdater.bind( this )
  }

  onSelectUpdater( updater ) {
    this.changePath( 'sim/updater', updater, false )
  }

  render() {
    const attr = this.props.attribute;
    const blueprint = this.props.blueprint;
    if ( attr == null ) {
      return <div />
    }
    const iValue = attr.sim && attr.sim.initialValue;
    const uProps = { attribute : attr, blueprint, onChange : this.onUpdaterChange }
    const updater = UpdaterFactory.createEditor( attr.sim && attr.sim.updater, uProps );
    
    return (
      <div>
        <BaseAttributeEditor {...this.props} />
        <Section header="Simulation">
  
          <Flex variant="vSpace" direction="column" align="stretch">

            <LabelGroup>
              <label>Initial Value</label>
              <TextInput
                hint="Initial Value..." 
                value={attr.sim && attr.sim.initialValue}
                onChange={( v, err ) => { this.changePath( 'sim/initialValue', v, err ) }} />
            </LabelGroup>

            { UpdaterSelector.hasCreators( attr ) && 
            (
              <LabelGroup>
                <label>Update With</label>
                <UpdaterSelector attribute={attr} updater={attr.sim && attr.sim.updater} onSelect={this.onSelectUpdater} />
              </LabelGroup>
            ) }
            {updater}
          </Flex>
        </Section>
      </div>
    ) 
  }
}
